// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tCze","left":"styles_left__28EX2"};